import { DoctorsServiceImpl } from './doctors/DoctorsServiceImpl'
import { FirestoreServiceImpl } from './http/FirestoreServiceImpl'
import { LocalStorageServiceImpl } from './local-storage/LocalStorageServiceImpl'
import { MemoryListServiceImpl } from './memory-list/MemoryListServiceImpl'
import { PatientServiceImpl } from './patient/PatientServiceImpl'
import {
  setDoctorsService,
  setLocalStorageService,
  setMemoryListService,
  setPatientService,
  setVisitService,
  setSecretaryService,
  setQueueService,
  setReferralService,
  setAppointmentService
} from './Services'
import { VisitServiceImpl } from './visit/VisitServiceImpl'
import { SecretaryServiceImpl } from './secretary/SecretaryServiceImpl'
import { QueueServiceImpl } from './queue/QueueServiceImpl'
import { ReferralServiceImpl } from './referral/ReferralServiceImpl'
import { AppointmentServiceImpl } from './appointment/AppointmentServiceImpl'

const firestoreService = new FirestoreServiceImpl()
const initServices = () => {
  setLocalStorageService(new LocalStorageServiceImpl())
  setPatientService(new PatientServiceImpl(firestoreService))
  setVisitService(new VisitServiceImpl(firestoreService))
  setMemoryListService(new MemoryListServiceImpl(firestoreService))
  setDoctorsService(new DoctorsServiceImpl(firestoreService))
  setSecretaryService(new SecretaryServiceImpl())
  setQueueService(new QueueServiceImpl())
  setReferralService(new ReferralServiceImpl())
  setAppointmentService(new AppointmentServiceImpl())
}

export const serviceRegistry = {
  initServices
}
